import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UniversitiesRoutingModule} from './universities-routing.module';
import {UniversitiesComponent} from './universities.component';
import {AddUniversityComponent} from './add-university/add-university.component';
import {ContentHeaderModule} from '../../layout/components/content-header/content-header.module';
import {TranslateModule} from '@ngx-translate/core';
import {CoreCommonModule} from '../../../@core/common.module';
import {CardSnippetModule} from '../../../@core/components/card-snippet/card-snippet.module';
import {NgxDatatableModule} from '@swimlane/ngx-datatable';
import {CoreSidebarModule} from '../../../@core/components';
import {NgbCarouselModule, NgbNavModule, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import {UniversityLandingComponent} from './university-landing/university-landing.component';
import {GoogleMapsModule} from '@angular/google-maps';
import {SharedModule} from '../../shared/shared.module';
import {ImageCropperModule} from 'ngx-image-cropper';
import {UniversityProgramsComponent} from './university-programs/university-programs.component';
import {UniversityCoursesComponent} from './university-courses/university-courses.component';
import {UniversityBranchesComponent} from './university-branches/university-branches.component';
import {AddUniversityProgramComponent} from './university-programs/add-university-program/add-university-program.component';
import {AddUniversityCourseComponent} from './university-courses/add-university-course/add-university-course.component';
import {AddUniversityBranchComponent} from './university-branches/add-university-branch/add-university-branch.component';
import {UniversityPcbMappingComponent} from './university-pcb-mapping/university-pcb-mapping.component';
import {AddUniversityPcbMappingComponent} from './university-pcb-mapping/add-university-pcb-mapping/add-university-pcb-mapping.component';
import {UniversityCoursesFeesComponent} from './university-courses-fees/university-courses-fees.component';
import {UniversityInfrastructureComponent} from './university-infrastructure/university-infrastructure.component';
import {UniversityAdmissionComponent} from './university-admission/university-admission.component';
import {UniversityContactComponent} from './university-contact/university-contact.component';
import {QuillModule} from 'ngx-quill';
import {EditorModule} from '@tinymce/tinymce-angular';
import {UniversityOverviewComponent} from './university-overview/university-overview.component';
import {UniversityStatComponent} from './university-stat/university-stat.component';
import {UniversityContentBlockComponent} from './university-content-block/university-content-block.component';
import {UniversityImportantDateComponent} from './university-important-date/university-important-date.component';
import {UniversityRankingComponent} from './university-ranking/university-ranking.component';
import {UniversityEmiLoanDetailComponent} from './university-emi-loan-detail/university-emi-loan-detail.component';
import {UniversityKeyHighlightComponent} from './university-key-highlight/university-key-highlight.component';
import {UniversityPlacementComponent} from './university-placement/university-placement.component';
import {UniversityWhyChooseDetailComponent} from './university-why-choose-detail/university-why-choose-detail.component';
import {UniversityCareerComponent} from './university-career/university-career.component';
import {UniversityRecruiterComponent} from './university-recruiter/university-recruiter.component';
import {UniversityFeeDetailsComponent} from './university-fee-details/university-fee-details.component';
import {UniversityFacultyComponent} from './university-faculty/university-faculty.component';
import {UniversitySuccessStoryComponent} from './university-success-story/university-success-story.component';
import {UniversityFaqComponent} from './university-faq/university-faq.component';
import {UniversityDetailShellComponent} from './university-detail-shell/university-detail-shell.component';
import {UniversityCourseListComponent} from './university-course-list/university-course-list.component';
import {UniversityPopularCoursesComponent} from './university-popular-courses/university-popular-courses.component';
import {AddUniversityInfrastructureComponent} from './university-infrastructure/add-university-infrastructure/add-university-infrastructure.component';

import { AddUniversityMarketingTagComponent } from './univerity-marketing-tag/add-university-marketing-tag/add-university-marketing-tag.component';
import {UniverityMarketingTagComponent} from './univerity-marketing-tag/univerity-marketing-tag.component';

@NgModule({
    declarations: [
        UniversitiesComponent,
        AddUniversityComponent,
        UniversityLandingComponent,
        UniversityProgramsComponent,
        UniversityCoursesComponent,
        UniversityBranchesComponent,
        AddUniversityProgramComponent,
        AddUniversityCourseComponent,
        AddUniversityBranchComponent,
        UniversityPcbMappingComponent,
        AddUniversityPcbMappingComponent,
        UniversityCoursesFeesComponent,
        UniversityInfrastructureComponent,
        UniversityAdmissionComponent,
        UniversityContactComponent,
        UniversityOverviewComponent,
        UniversityStatComponent,
        UniversityContentBlockComponent,
        UniversityImportantDateComponent,
        UniversityRankingComponent,
        UniversityEmiLoanDetailComponent,
        UniversityKeyHighlightComponent,
        UniversityPlacementComponent,
        UniversityWhyChooseDetailComponent,
        UniversityCareerComponent,
        UniversityRecruiterComponent,
        UniversityFeeDetailsComponent,
        UniversityFacultyComponent,
        UniversitySuccessStoryComponent,
        UniversityFaqComponent,
        UniversityDetailShellComponent,
        UniversityCourseListComponent,
        UniversityPopularCoursesComponent,
        AddUniversityInfrastructureComponent,
        UniverityMarketingTagComponent,
        AddUniversityMarketingTagComponent
    ],
    imports: [
        CommonModule,
        UniversitiesRoutingModule,
        ContentHeaderModule,
        TranslateModule,
        CoreCommonModule,
        CardSnippetModule,
        NgxDatatableModule,
        CoreSidebarModule,
        NgbPaginationModule,
        NgbCarouselModule,
        NgbNavModule,
        GoogleMapsModule,
        SharedModule,
        ImageCropperModule,
        QuillModule,
        EditorModule
    ],
    exports: [UniversitiesComponent, AddUniversityComponent, UniversityLandingComponent]
})
export class UniversitiesModule {
}
